import styled from 'styled-components';
import WithDirection from '@iso/lib/helpers/rtl';

const ActivityWrap = styled.div`
  max-height:400px;
  overflow:auto;

  .btn-success{
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    &:hover{
      opacity: 0.8;
    }
  }
  .btn-n-br{
    border:none;
  }
  .wrap-card-activity{
    position:relative;
  }
  .btn-edit-activity{
    color: #0B2A1B;
  }
  .btn-delete-activity{
    color: red;
  }
  .card-activity-title{
    text-transform: capitalize;
    margin-bottom: 20px;
  }

  a,.ant-btn:hover{
    border-color: #0B2A1B;
    color:#0B2A1B
  }
  
  .attachment-activity{
    text-transform: none;
    color: #0B2A1B;
  }
  .wrap-btn-activity {
    position: absolute;
    top: 10px;
    right: 0;
    z-index: 1;
  }
  .ant-modal-body{
    padding: 0;
  }
  .form-title{
    padding: 16px 24px;
    border-bottom: 1px solid #eaeef1;
    h3{
      font-size: 1rem;
    }
  }
  .form-body{
    padding: 12px 24px 12px 24px;
    .checkbox-contact{
      margin-bottom: 10px;
    }
  }
  
`;

export default WithDirection(ActivityWrap);